module.exports = __webpack_public_path__ + "img/blur-hooks.644ed695.jpg";